import { GET_API_URL } from 'shared/config'
import { type IResponseToken } from 'entities/Auth'

export const getBaseApiParams = (token: IResponseToken) => {
  return {
    baseURL: GET_API_URL(),
    headers: {
      'Content-type': 'application/json',
      'Salesmsg-App': 'react',
      Authorization: `${token.token_type} ${token.access_token}`,
    },
  }
}
